import React, { useEffect, useState } from 'react'
import T from 'prop-types'
import { isEqual } from 'date-fns'
import { DesktopDateTimePicker } from '@mui/x-date-pickers'

import InputLabel from './InputLabel'

export default function DateTimePicker({
  id,
  label,
  value,
  error = null,
  readOnly,
  handleDateChange = () => {},
  ...pickerProps
}) {
  const [localValue, setLocalValue] = useState(value)

  useEffect(() => {
    setLocalValue(value)
  }, [value])

  const handleLocalChange = (newDate) => {
    setLocalValue(newDate)
  }

  const handleClose = () => {
    setLocalValue(value)
  }

  const handleAccept = (newDate) => {
    setLocalValue(newDate)
    !isEqual(newDate, value) &&
      handleDateChange(
        isNaN(newDate) || newDate === null ? newDate : newDate.toISOString(),
        id
      )
  }

  return (
    <>
      <InputLabel
        label={label}
        inputId={id}
        sx={{ paddingBottom: (theme) => theme.spacing(1) }}
      />
      <DesktopDateTimePicker
        id={id}
        value={localValue}
        onChange={handleLocalChange}
        onClose={handleClose}
        onAccept={handleAccept}
        ampm={false}
        disableHighlightToday={true}
        minutesStep={1}
        timeSteps={{
          minutes: 1,
          hours: 1,
        }}
        disabled={readOnly}
        readOnly={readOnly}
        slotProps={{
          textField: {
            size: 'small',
            error: !!error,
            helperText: error,
            inputProps: {
              'data-testid': `date-time-picker-${id}`,
            },
          },
        }}
        {...pickerProps}
      />
    </>
  )
}

DateTimePicker.propTypes = {
  id: T.string.isRequired,
  label: T.string.isRequired,
  value: T.instanceOf(Date),
  error: T.string,
  readOnly: T.bool,
  pickerProps: T.array,
  handleDateChange: T.func,
}
